import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useEffect, useState } from 'react';
import { WindowLevel } from '~/domain/patient/windowLevel';
import useWindowLevel from '~/hooks/useWindowLevel';

const windowingPresets = [
    { name: 'Abdomen (400, 40)', ww: 400, wc: 40 },
    { name: 'Bone (1600, 500)', ww: 1600, wc: 500 },
    { name: 'Brain (85, 30)', ww: 85, wc: 30 },
    { name: 'Breast (400, -50)', ww: 400, wc: -50 },
    { name: 'Dental (3000, 900)', ww: 3000, wc: 900 },
    { name: 'Liver (160, 50)', ww: 160, wc: 50 },
    { name: 'Lung (1600, -600)', ww: 1600, wc: -600 },
    { name: 'Metal (1, 2800)', ww: 1, wc: 2800 },
    { name: 'Neck (325, 65)', ww: 325, wc: 65 },
    { name: 'Pelvis (500, 0)', ww: 500, wc: 0 },
    { name: 'Prostate (210, -35)', ww: 210, wc: -35 },
    { name: 'Soft Tissue (350, 40)', ww: 350, wc: 40 },
];

export default function WindowingPresets() {
    const [selectedPreset, setSelectedPreset] = useState<string>('');
    const { windowLevel, setWindowLevel } = useWindowLevel();

    useEffect(() => {
        if (!windowLevel) return;
        // Check if current windowingLevels match any preset
        const currentPreset = windowingPresets.find(
            (preset) =>
                preset.ww === windowLevel.window &&
                preset.wc === windowLevel.level
        );
        if (!currentPreset && selectedPreset) {
            setSelectedPreset('');
        } else if (currentPreset && !selectedPreset) {
            setSelectedPreset(currentPreset.name);
        }
        // Changing windowing level triggers this useEffect
        // This will change for example when Slider inputs is changing
    }, [windowLevel]);

    const handleChange = (event: SelectChangeEvent) => {
        setSelectedPreset(event.target.value);
        const selectedPreset = windowingPresets.find(
            (p) => p.name === event.target.value
        );
        if (selectedPreset) {
            setWindowLevel(new WindowLevel(selectedPreset.ww, selectedPreset.wc));
        }
    };

    return (
        <FormControl size="small" fullWidth>
            <InputLabel id="windowing-preset-select-label">
                {selectedPreset ? 'Preset' : 'Select preset'}
            </InputLabel>
            <Select
                labelId="windowing-preset-select-input"
                id="preset"
                value={selectedPreset}
                label={selectedPreset.length ? 'Preset' : 'Select preset'}
                onChange={handleChange}
            >
                {windowingPresets.map((preset) => (
                    <MenuItem key={preset.name} value={preset.name}>
                        {preset.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
